import React from 'react';
import { View, Text, TouchableOpacity, Modal, ScrollView, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

const ShipmentSelectionModal = ({ 
  visible, 
  order, 
  shipments, 
  onSelectShipment, 
  onClose
}) => {
  
  const getStatusColor = (status) => {
    return status === 'scanned' ? '#10b981' : '#f59e0b';
  };

  const getStatusText = (status) => {
    return status === 'scanned' ? 'COMPLETE' : 'NEEDS SCANNING';
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.modalOverlay}>
        <View style={styles.modalContainer}>
          {/* Header */}
          <View style={styles.header}>
            <View>
              <Text style={styles.headerTitle}>Order #{order?.increment_id}</Text>
              <Text style={styles.headerSubtitle}>
                {order?.firstname} {order?.lastname}
              </Text>
              {order?.address_1 && (
                <Text style={styles.headerAddress}>{order.address_1}</Text>
              )}
            </View>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Text style={styles.closeButtonText}>✕</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.selectTitle}>Select Shipment to Scan:</Text>

          {/* Shipments List */}
          <ScrollView style={styles.shipmentsContainer}>
            {shipments && shipments.map((shipment, index) => {
              const isScanned = shipment.status === 'scanned';
              const isClickable = !isScanned;

              return (
                <TouchableOpacity
                  key={shipment.id}
                  style={[
                    styles.shipmentCard,
                    { borderLeftColor: getStatusColor(shipment.status) },
                    isScanned && styles.shipmentCardDisabled
                  ]}
                  onPress={() => isClickable && onSelectShipment(shipment)}
                  disabled={!isClickable}
                >
                  {/* Status Badge */}
                  <View style={[
                    styles.statusBadge,
                    { backgroundColor: getStatusColor(shipment.status) }
                  ]}>
                    <Text style={styles.statusBadgeText}>
                      {getStatusText(shipment.status)}
                    </Text>
                  </View>

                  {/* Shipment Number */}
                  <Text style={styles.shipmentNumber}>
                    Shipment {index + 1}
                  </Text>

                  {/* Tracking Number */}
                  {shipment.tracking_number && (
                    <Text style={styles.shipmentDetail}>
                      Tracking: {shipment.tracking_number.slice(-10)}
                    </Text>
                  )}

                  {/* Progress */}
                  <Text style={styles.shipmentProgress}>
                    Items: {shipment.scanned_qty}/{shipment.total_qty} scanned
                  </Text>

                  {/* Select Button */}
                  {isClickable && (
                    <LinearGradient
                      colors={['#f59e0b', '#d97706']}
                      style={styles.selectButton}
                    >
                      <Text style={styles.selectButtonText}>SELECT TO SCAN</Text>
                    </LinearGradient>
                  )}
                </TouchableOpacity>
              );
            })}
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    width: '90%',
    maxWidth: 600,
    maxHeight: '80%',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  headerSubtitle: {
    fontSize: 16,
    color: '#6b7280',
    marginTop: 4,
  },
  headerAddress: {
    fontSize: 14,
    color: '#9ca3af',
    marginTop: 2,
  },
  closeButton: {
    padding: 8,
  },
  closeButtonText: {
    fontSize: 24,
    color: '#6b7280',
  },
  selectTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 15,
  },
  shipmentsContainer: {
    maxHeight: 400,
  },
  shipmentCard: {
    backgroundColor: '#f9fafb',
    borderRadius: 8,
    padding: 16,
    marginBottom: 12,
    borderLeftWidth: 4,
  },
  shipmentCardDisabled: {
    opacity: 0.6,
  },
  statusBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    marginBottom: 12,
  },
  statusBadgeText: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
  },
  shipmentNumber: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 8,
  },
  shipmentDetail: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 4,
  },
  shipmentProgress: {
    fontSize: 16,
    fontWeight: '600',
    color: '#374151',
    marginTop: 8,
  },
  shipmentDate: {
    fontSize: 12,
    color: '#9ca3af',
    marginTop: 4,
  },
  selectButton: {
    marginTop: 12,
    paddingVertical: 12,
    borderRadius: 6,
    alignItems: 'center',
  },
  selectButtonText: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
  },
});

export default ShipmentSelectionModal;

